<template>
  <a></a>
</template>

<script>
export default {
  name: "DevicePage"
}
</script>

<style scoped>

</style>